import CircularLessIcon from './CircularLessIcon';
export default CircularLessIcon;
